/**
 * Agent backend selector.
 *
 * One place decides which `AgentBackend` the app uses: the hosted Argo
 * agent-worker when `VITE_AGENT_API_URL` is configured, otherwise the
 * deterministic local parser. Consumers import `agentBackend` and call
 * `.interpret(...)` — they never branch on which one it is, so flipping
 * the env flag swaps simulation for the live pipeline with no code change.
 */

import type { AgentBackend } from './types';
import { localBackend } from './localBackend';
import { remoteBackend } from './remoteBackend';
import { isConfigured } from './argoWorker';

/** Pick the backend at module load based on the runtime config. */
function selectBackend(): AgentBackend {
  return isConfigured() ? remoteBackend : localBackend;
}

/** The active backend for chat interpretation. */
export const agentBackend: AgentBackend = selectBackend();
